import styled, { css } from 'styled-components'
import { colors } from '../../../styles/constants'

export const CardWrapper = styled.div`
  margin: 0;
  margin-bottom: 16px;
`
export const CardBody = styled.div`
  width: 100%;
  hr {
    margin: 16px 0;
  }
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  ${({ customIconColor }) => customIconColor && css`
    svg path {
      fill: ${customIconColor};
    }
  `}
`

export const CardTitle = styled.div`
  max-width: 180px;
  * {
    line-height: 19px;
  }
  h1 {
    font-family: 'Nunito';
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.96px;
    color: ${({ customTitleColor }) => customTitleColor ?? colors.gray.darker};
    margin-bottom: 4px;
  }

  h2 {
    font-family: 'Open Sans';
    font-weight: 400;
    font-size: 13px;
    color: ${colors.gray.dark};
    margin-bottom: 0;
  }
`
export const Chevron = styled.div`
  cursor: pointer;
  margin-left: auto;
  color: ${colors.cyan.default};
`

export const ExpandedContent = styled.div`
  width: 100%;
  hr:first-child {
    margin-top: 0;
  }
`
